import React from 'react';
import { Div, RowDiv, RowListItem, Section, Text } from 'styles';
import { Button, Dropdown, Img, InfoDiv, Input, LineText, SubTitle } from 'components';

export function SettingEnergy({ spaceHeader, values, onChange, reset, submit, invalids, active }) {
  return (
    <Section>
      <SubTitle title="에너지 소비 예측" desc="Energy_에너지 소비 예측" />
      <InfoDiv $alignItems="flex-start" $paddingTop={6}>
        에너지 소비량/온도,습도 항목에 대한 예측 데이터를 추출할 수 있습니다.
        <br />
        비교하고자 하는 케이스에 대한 정보를 입력하고 Submit 버튼을 클릭하세요.
      </InfoDiv>
      <Div $marginTop={32}>
        <LineText>시뮬레이션 정보 입력</LineText>
        <Div $marginTop={24} $width={720}>
          <Input name="name" value={values.name} onChange={onChange} label="시뮬레이션 명" placeholder="이름 입력" />
        </Div>
        <Div $marginTop={24} $height={240} $minHeight={240}>
          <Img src="energy" />
        </Div>
      </Div>
      <Div $marginTop={32}>
        <LineText>공간 정보 입력</LineText>
        <RowDiv $marginTop={12} $borderRadius={8} $padding="15px 16px" $border={{ color: 'gray100' }}>
          {spaceHeader.map((header, index) => (
            <Div
              key={`space_${index}`}
              $minWidth={(index === 0 && 120) || 128}
              $maxWidth={index === 0 && 120}
              $flex={1}
              $padding="0 2px"
            >
              <Text $type="m" $textAlign="center">
                {header}
              </Text>
            </Div>
          ))}
        </RowDiv>
        <ul>
          {/* {['case1', 'case2', 'case3'].map((name, caseIndex) => */}
          {['case1'].map((name, caseIndex) =>
            values[name].map((item, index) => (
              <RowListItem
                key={`${name}_${index}`}
                $padding="16px"
                $alignItems="center"
                $bgColor={caseIndex % 2 !== 0 && 'gray50'}
                $borderBottom={{ color: 'gray100' }}
              >
                <Div $minWidth={120} $width={120} $padding="0 2px">
                  <Text>Case 0{caseIndex + 1}</Text>
                </Div>
                {Object.keys(item).map((key) => (
                  <Div key={`${name}_${key}`} $padding="0 2px" $flex={1}>
                    <Input
                      name={`${name}.${key}`}
                      value={values[name][index][key]}
                      type="number"
                      step="0.1"
                      onChange={onChange}
                      $padding="7px 12px"
                    />
                  </Div>
                ))}
              </RowListItem>
            )),
          )}
        </ul>
        <RowDiv $marginTop={32} $justifyContent="flex-end" $gap={8}>
          <Button $size="default" $type="sub" onClick={reset}>
            Reset
          </Button>
          <Button $size="default" onClick={submit} disabled={!active}>
            Submit
          </Button>
        </RowDiv>
      </Div>
    </Section>
  );
}
